import { gql } from '@apollo/client';

export const GET_EXERCISES = gql`
  query GetExercises {
    getExercises {
      id
      name
      category
      equipment
      isStandard
    }
  }
`;

export const GET_EXERCISE_LOGS = gql`
  query GetExerciseLogs($date: String, $exerciseId: ID) {
    getExerciseLogs(date: $date, exerciseId: $exerciseId) {
      id
      date
      exercise {
        id
        name
        category
        equipment
        isStandard
      }
      sets {
        reps
        weight
        rpe
        completed
      }
    }
  }
`;

export const CREATE_EXERCISE = gql`
  mutation CreateExercise($input: ExerciseInput!) {
    createExercise(input: $input) {
      id
      name
      category
      equipment
      isStandard
    }
  }
`;

export const CREATE_EXERCISE_LOG = gql`
  mutation CreateExerciseLog($input: ExerciseLogInput!) {
    createExerciseLog(input: $input) {
      id
      date
      exercise {
        id
        name
        category
        equipment
      }
      sets {
        reps
        weight
        rpe
        completed
      }
    }
  }
`;

export const UPDATE_EXERCISE_LOG = gql`
  mutation UpdateExerciseLog($id: ID!, $input: ExerciseLogInput!) {
    updateExerciseLog(id: $id, input: $input) {
      id
      date
      exercise {
        id
        name
        category
        equipment
      }
      sets {
        reps
        weight
        rpe
        completed
      }
    }
  }
`;

export const DELETE_EXERCISE_LOG = gql`
  mutation DeleteExerciseLog($id: ID!) {
    deleteExerciseLog(id: $id)
  }
`;
